import { usePageMeta } from "@/hooks/usePageMeta";
import HeroCarousel from "./components/HeroCarousel";
import HighlightSection from "./components/HighlightSection";
import FeaturedFoods from "./components/FeaturedFoods";
import CourierSection from "./components/CourierSection";
import PromoSection from "./components/PromoSection";
import TestimonialSection from "./components/TestimonialSection";
import IntroSection from "./components/IntroSection";

export default function Home() {
  usePageMeta(
    "美味的快递 - 优质美食外卖与快速快递服务平台",
    "美味的快递提供丰富多样的美食外卖选择和便捷的快递配送服务，满足您对美味与速度的双重需求，轻松享受品质生活。",
    "美味的快递,美食外卖,快递服务,美食配送,快捷外卖,在线点餐,美味快送,外卖平台"
  );

  return (
    <div className="flex flex-col">
      <HeroCarousel />
      <HighlightSection />
      <FeaturedFoods />
      <CourierSection />
      <PromoSection />
      <TestimonialSection />
      <IntroSection />
    </div>
  );
}